// @flow

export default {
  EXTRA_SMALL: 320,
  SMALL: 375,
  MEDIUM: 768,
  LARGE: 1024,
  EXTRA_LARGE: 1440,

  abbreviationToScreenSize(abbreviation: string): number {
    switch (abbreviation) {
      case 'xs':
        return this.EXTRA_SMALL;
      case 'sm':
        return this.SMALL;
      case 'md':
        return this.MEDIUM;
      case 'lg':
        return this.LARGE;
      case 'xl':
        return this.EXTRA_LARGE;
    }
  }
};
